// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ayrqhwxqdsnyauphyxwr.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5cnFod3hxZHNueWF1cGh5eHdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODEyNDI2ODgsImV4cCI6MTk5NjgxODY4OH0.WcOyqLuTuaz3K7fvJigKjwy0hhURKe10FtJOBVgNDfI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);